import { render } from "./Mailinfo.vue?vue&type=template&id=69175b51"
import script from "./Mailinfo.vue?vue&type=script&lang=js"
export * from "./Mailinfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__